<div class="flex items-center justify-center">
  <lib-perio-form-tooth-navigator-button type="back" (buttonClick)="onBackButtonClick()" [isDisabled]="isFirstTooth()" />
  <div class="flex w-16 flex-col items-center justify-center font-thin">
    <lib-perio-form-tooth-navigator-button
      type="up"
      (buttonClick)="onUpButtonClick()"
      [isDisabled]="activeJaw() === 'upper' && currentSide() === 'buccal'"
    />
    <span class="text-[40px]">{{ toothNumber() }}</span>
    <lib-perio-form-tooth-navigator-button
      type="down"
      (buttonClick)="onDownButtonClick()"
      [isDisabled]="activeJaw() === 'lower' && currentSide() === 'buccal'"
    />
  </div>
  <lib-perio-form-tooth-navigator-button type="next" (buttonClick)="onNextButtonClick()" [isDisabled]="isLastTooth()" />
</div>
